import { z } from 'zod'

export type GetUserLikesPropertyResponseType = z.infer<typeof GetUserLikesPropertyResponse>
export const GetUserLikesPropertyResponse = z
  .object({
    propertyId: z.number().optional().nullable(),
  })
  .nullable()
